import {
  GameAction,
  GameActionDispatchContext,
  GameStateContext,
  useGameReducer,
} from "app/game/useGameState";

import { useEffectOnce } from "react-use";

interface GameStateProviderProps {
  storageKey?: string;
  children: React.ReactNode;
}

export default function GameStateProvider({
  storageKey,
  children,
}: GameStateProviderProps) {
  const [gameState, dispatch] = useGameReducer(storageKey);

  useEffectOnce(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has("reset")) {
      dispatch({ type: GameAction.GAME_RESET });
    }
  });

  return (
    <GameStateContext.Provider
      value={{
        ...gameState,
      }}
    >
      <GameActionDispatchContext.Provider value={dispatch}>
          {children}
      </GameActionDispatchContext.Provider>
    </GameStateContext.Provider>
  );
}
